import { reduce } from "et3-type-guards";

import i18n from "../../../constants/i18n";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import Et3Margin from "../../et3-ui/ET3Margin";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import SelectAll from "../../../routes/khattabat/matching/shared/SelectAll";
import getKhattabatMatchingStore from "../../../stores/khattabat-stores/matching-stores";
import getKhattabat101MGeneralStore from "../../../stores/khattabat-stores/101m-stores/general-101m-store";

const KhattabatMatchingResultsPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;

  const matchesIds = reduce(
    () => getKhattabatMatchingStore().matchesIds.get(),
    []
  );

  const selectedMatchesCount = reduce(
    () => getKhattabatMatchingStore().selectedMatchesCount.get(),
    0
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1000}
        height={760}
        color={colors.all.white}
        style={{
          position: "relative",
          borderRadius: 50,
          zIndex: 5,
          padding: 25
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={24}
          text={i18n.get("KHATTABAT_MATCHING_RESULTS")}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />

        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="space-between"
          alignItems="center"
          withShadow={false}
          width={850}
          height={60}
          color={colors.all.white}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"LIGHT"}
            fontSize={22}
            isSpan={true}
            text={`${i18n.get(
              "KHATTABAT_SELECTED_MATCHES"
            )}: ${selectedMatchesCount}`}
            style={{
              height: 50 * unitY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            color={colors.all.black}
          />

          <SelectAll
            onClick={() => {
              const isAllSelected =
                matchesIds.length > 0 &&
                selectedMatchesCount === matchesIds.length;

              getKhattabat101MGeneralStore().toggleIsMatchesIdsSelectedAll();

              getKhattabatMatchingStore().setSelectedMatchesIds(
                isAllSelected ? [] : matchesIds
              );
            }}
            state={
              matchesIds.length > 0 &&
              selectedMatchesCount === matchesIds.length
            }
          />
        </ET3Div>

        <ET3Div
          isScrollable={true}
          isExtendable={false}
          fDirection="column"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={850}
          height={500}
          color={colors.all.white}
          style={{
            border: `1px solid ${colors.all.black}`,
            borderRadius: 8,
            overflowY: "auto"
          }}
          onClick={() => {}}
        >
          {matchesIds.map((userID) => {
            const isChecked =
              getKhattabatMatchingStore().isMatchUserSelected(userID);

            return (
              <ET3Div
                key={userID}
                isScrollable={false}
                isExtendable={false}
                fDirection="row"
                justifyContent="flex-start"
                alignItems="center"
                withShadow={false}
                width={800}
                height={55}
                color={colors.all.white}
                style={{
                  borderBottom: `1px solid ${colors.all.black}`
                }}
                onClick={() => {
                  getKhattabatMatchingStore().toggleSelectedMatchUser(userID);
                }}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => {
                    getKhattabatMatchingStore().toggleSelectedMatchUser(userID);
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                  style={{
                    width: 18,
                    height: 18,
                    cursor: "pointer"
                  }}
                />

                <Et3Margin top={0} bottom={0} left={15} right={0} />

                <Et3Text
                  fontFamily={"BOLD"}
                  fontSize={22}
                  isSpan={true}
                  text={`${userID}`}
                  style={{
                    height: 50 * unitY,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  color={colors.all.black}
                />
              </ET3Div>
            );
          })}
        </ET3Div>

        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="center"
          alignItems="center"
          withShadow={false}
          width={850}
          height={70}
          color={colors.all.white}
          style={{}}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            fDirection="row"
            justifyContent="center"
            alignItems="center"
            withShadow={false}
            width={170}
            height={50}
            color={colors.all.blue}
            style={{
              border: `1px solid ${colors.all.black}`,
              borderRadius: 6,
              cursor: "pointer"
            }}
            onClick={() => {
              return getCorePopUpStore().closeConfirmationPopUps();
            }}
          >
            <Et3Text
              fontFamily={"BOLD"}
              fontSize={22}
              isSpan={true}
              text={i18n.get("CONFIRM")}
              style={{
                height: 50 * unitY,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              color={colors.all.white}
            />
          </ET3Div>
        </ET3Div>
      </ET3Div>
    </ET3Div>
  );
});

export default KhattabatMatchingResultsPopUp;
